import { jsx as _jsx } from "react/jsx-runtime";
import cls from 'classnames';
import styles from './FormGroup.module.css';
function FormGroup(props) {
    const { className, children } = props;
    return _jsx("div", { className: cls(styles.formGroup, className), children: children });
}
export default FormGroup;
